import React, { Component } from 'react'
import PropTypes from 'prop-types'
import loader from '../loader.gif'
import submit from '../submit.gif'
import logo from '../logo.gif'

export default class UploadDocuments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      files: [],
      uploadFiles: [],

      nationalIDUploadFiles : [],
      nationalIDFiles : [],

      passportUploadFiles : [],
      passportFiles : [],

      englsihAssessmentUploadFiles : [],
      englishAssessmentFiles : [],

      transferUploadFiles : [],
      transferFiles : [],

      personalPicUploadFiles : [],
      personalPicFiles : [],

      courseDescriptionsUploadFiles : [],
      courseDescriptionsFiles : [],


      gradingSchemeUploadFiles : [],
      gradingSchemeFiles : [],


      loading: true,
      showModal: false,
      error: '',
      submitLoading: false,
      accepts: '',
      numberOfUpload: 0,
      maxAttachmentSize : 0,
      maxApplicationAttachmentSize : 0,
      color: 'red',
      disable: false,
  
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.toBase64 = this.toBase64.bind(this)
  }

  componentDidMount() {

    fetch(`${process.env.REACT_APP_API_URL}/api/attachment/GetFileTypes`)
      .then(res => res.json())
      .then(res => {
        this.setState({ accepts: res })
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}//api/attachment/GetMaxAttachmentNumber`))
      .then(res => res.text())
      .then(res => {
        this.setState({ numberOfUpload: parseInt(res) })
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}//api/attachment/GetMaxAttachmentSize`))
      .then(res => res.text())
      .then(res => {
        this.setState({ maxAttachmentSize: parseInt(res) })
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}//api/attachment/GetMaxApplicationAttachmentSize`))
      .then(res => res.text())
      .then(res => {
        this.setState({ maxApplicationAttachmentSize: parseInt(res) })
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}/api/login/getprefilleddata`, {
        method: 'POST',
        body: JSON.stringify({
          IncompleteApplicationId: this.props.incompleteApplicationId || parseInt(sessionStorage.getItem('id')),
          Token: this.props.token || sessionStorage.getItem('token') || sessionStorage.getItem('token')
        }),
        headers: {
          'Content-Type': 'application/json'
        }
      }))
      .then(res => res.json())
      .then(res => {
        if (res.StatusCode === 200) {
           if (res.data.Validated === false) {
           /* const { history } = this.props
           // history.push('/')
            return */
          } 
          this.setState({ loading: false })
        }
      })

      .catch(err => console.log(err))
  }


  handleDelete(index) {
    const files = [...this.state.files]
    files.splice(index, 1)
    this.setState({ files: files })
  }

  async toBase64() {
    const { files } = this.state
    const toBase64 = async file => new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        let result = reader.result.split(",")[1]
        return resolve(result)
      }
      reader.onerror = error => reject(error)
    })
      .then((res) => {
        return res
      })
      .catch(err => console.log(err))

    const promiseArray = files.map(element => toBase64(element))
    return Promise.all(promiseArray)
      .then((res, rej) => {
        if (rej) throw rej
        const returnArray = []
        files.forEach((element, i) => {
          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
          returnArray.push({
            IncompleteApplicationId: this.props.incompleteApplicationId || sessionStorage.getItem('id'),
            fileName: element.typelabel + '-' +element.name,
            fileExtension: extension,
            fileContent: res[i],
            label: element.label,
            typelabel:element.typelabel
          })
        })
        return returnArray
      })
      .catch(err => console.log(err))
  }

  handleSubmit() {
    this.setState({ submitLoading: true })

   this.toBase64()
      .then((res) => fetch(`${process.env.REACT_APP_API_URL}/api/Submit/SubmitIncompleteApplication`,{
        method: 'POST',
        body: res.length ? JSON.stringify(res) : JSON.stringify([{ IncompleteApplicationId: this.props.incompleteApplicationId || sessionStorage.getItem('id') }]),
        headers: {
          'Content-Type': 'application/json'
        }
      })
    )
      .then(res => res.json())
      .then(res => {
        if (res.StatusCode === 200) {    
        // this.setState({ error: 'Your application has been submitted successfully', color: 'green', submitLoading: false, disable: true })
         this.setState({ error: '', color: 'green', submitLoading: false, disable: true })  
         //window.open(res.PaymentGatewayURL + '?TransactionID=' + res.PaymentTransactionId + "&TransactionAmount=" + res.Amount, '_parent');  
         window.location.replace(res.Data.redirect_url);
        } else if (res.StatusCode === 409) {
          this.setState({ error: 'Application already submitted', color: 'green', submitLoading: false, disable: true })  
          alert('Application already submitted') 
        }
        else
        {
          this.setState({ error: res.Msg, submitLoading: false, color: 'red' })
        }
      })
      .catch(err => {
        console.log(err)
        this.setState({ error: 'Some error Occured. Please retry', submitLoading: false })
      })
  }

  render() {
    const {  loading, files , numberOfUpload,maxAttachmentSize,maxApplicationAttachmentSize, accepts, color, uploadFiles, nationalIDUploadFiles,
      passportUploadFiles ,englsihAssessmentUploadFiles , transferUploadFiles , personalPicUploadFiles,courseDescriptionsUploadFiles,gradingSchemeUploadFiles, error, submitLoading, showModal, disable }

    = this.state
    if (loading) {
      return (
        <div id="mainContainer">
          <div id="designBorder">
           
            <div id="main-page" style={{ display: 'flex', justifyContent: 'center' }}>
              <img src={loader} style={{
                justifyContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }} alt="Loading..." />
            </div>
          </div>
        </div>
      )
  
    }


    let acceptFiles = ''
    const acceptArray = []
    accepts.forEach((element, i) => {
      if (i === accepts.length - 1) {
        acceptFiles += element.type
      } else { acceptFiles += element.type + ',' }
      acceptArray.push(element.type)
    })
    const showFiles = []
    let total = 0

     files.forEach((element, index) => {

      total += parseFloat(element.size)

      if( Math.round((total / 1000000) * 100) / 100 <= maxApplicationAttachmentSize  )
      {
      showFiles.push(
        <tr>
          <td>{element.name}</td>
          <td>{element.name.split('.')[(element.name.split('.')).length - 1]}</td>
          <td>{Math.round((element.size / 1000000) * 100) / 100}</td>
          <td>{element.typelabel}</td>
          <td>
            <img
              src={require('../delete.png')}
              style={{ width: 15, height: 15 }}
              onClick={disable ? null : this.handleDelete.bind(this, index)}
              alt='Delete'
            />
          </td>
        </tr>
      )
      }
      else
      {
       
        alert('Upload Failed,maximum allowed upload Attachments size per Application was exceeded !')
        this.handleDelete(index)
        total -= parseFloat(element.size)
      }
    })

    return (

      <div id="mainContainer">
        <div id="designBorder">
        <img src={logo} className="center main-logo"></img>
          <div id="main-page">
            <div id="applicationForm">
              <h4 className='app-heading'>Upload Attachments</h4>
              <button
                className="save"
                onClick={this.props.onClick}
                id="logout-button"
              >Logout</button>
            </div>
            <p>If needed, you can attach up to {numberOfUpload} file(s) to your application</p>
            <p>The Maximum allowed size per Attachment size is: {maxAttachmentSize} MB</p>
            <p>The Maximum allowed Attachments size per Application is: {maxApplicationAttachmentSize} MB </p>
            <p>If your transcripts/documents consist of several pages, kindly note that you are required to combine them into one PDF file.</p>

            {/*<p className="file-support-text" style={{ color: '#3168cd', textDecoration: 'underline' }}><i className="fa fa-info-circle" aria-hidden="true"></i>View Supported File Types</p>*/}

            <div
                onClick={() => this.setState({ showModal: true })} style={{ cursor: 'pointer' }}
              >
                <p className="file-support-text" style={{ color: '#3168cd', textDecoration: 'underline' }}><i className="fa fa-info-circle" aria-hidden="true"></i>View Supported File Types</p>
              </div>
           
           <div style={{ flexDirection: 'row', display: 'flex', alignItems: 'center' }}>
              <div>
                <input
                  type="file"
                  style={{ display: 'none' }}
                  required={true}
                  hover='is required'
                  multiple={true}
                  id="file-input"
                  onClick={(e) => {
                    if (disable) {
                      e.preventDefault()
                    }
                    e.target.value = null //when upload file still didn't trigger onChange for the same file 
                    
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const filesss = e.target.files
                      const processFiles = Array.from(e.target.files)
                      if ((filesss.length + files.length) > numberOfUpload) {
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        processFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "HighSchoolTranscript";
                          element.typelabel="High School Transcript"

                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {   
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }
                         /*  if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/
                        })
                        if (count === 1) {
                          this.setState({ files: [...this.state.files, ...Array.from(filesss)], uploadFiles: [...uploadFiles, filesss] })
                        } else if (count ===0) { alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                 
                  accept={acceptFiles} />
              <input
                  type="file"
                  style={{ display: 'none' }}
                  required={true}
                  errMsg='National ID is required'
                  multiple={true}
                  id="nationalID-file-input"
                  onClick={(e) => {
                    e.target.value = null
                    if (disable) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const nationalIDfilesss = e.target.files
                      const nationalIDProcessFiles = Array.from(e.target.files)
                      if ((nationalIDfilesss.length + files.length) > numberOfUpload) {
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        nationalIDProcessFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "NationalID";
                          element.typelabel = "National ID or Birth Certificate"

                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }
                          /*if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/
                        })
                        if (count === 1) {
                          this.setState({ files: [...this.state.files,...this.state.nationalIDFiles,
                             ...Array.from(nationalIDfilesss)], 
                             nationalIDUploadFiles: [...nationalIDUploadFiles, nationalIDfilesss] })
                        } else if (count === 0) { alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                  accept={acceptFiles} />

                <input
                  type="file"
                  style={{ display: 'none' }}
                  multiple={true}
                  id="passport-file-input"
                  onClick={(e) => {
                    e.target.value = null
                    if (disable) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const passportfilesss = e.target.files
                      const passportProcessFiles = Array.from(e.target.files)
                      if ((passportfilesss.length + files.length) > numberOfUpload) {
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        passportProcessFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "Passport";
                          element.typelabel = "Passport";
                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }
                          /*if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/
                        })

                        if (count === 1) {
                          this.setState({ files: [...this.state.files,...this.state.passportFiles, ...Array.from(passportfilesss)], passportUploadFiles: [...passportUploadFiles, passportfilesss] })
                        } else if (count === 0) { alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                  accept={acceptFiles} />

                <input
                  type="file"
                  style={{ display: 'none' }}
                  multiple={true}
                  id="englishAssessment-file-input"
                  onClick={(e) => {
                    e.target.value = null
                    if (disable) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const englishAssessmentFilesss = e.target.files
                      const englishAssessmentProcessFiles = Array.from(e.target.files)
                      if ((englishAssessmentFilesss.length + files.length) > numberOfUpload) {
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        englishAssessmentProcessFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "EnglishAssessment";
                          element.typelabel = "English Assessment"
                         /* if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/

                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }
                        })
                        if (count === 1) {
                          this.setState({ files: [...this.state.files,...this.state.englishAssessmentFiles, ...Array.from(englishAssessmentFilesss)], englsihAssessmentUploadFiles: [...englsihAssessmentUploadFiles, englishAssessmentFilesss] })
                        } else if (count === 0) { alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                  accept={acceptFiles} />

                <input
                  type="file"
                  style={{ display: 'none' }}
                  multiple={true}
                  id="transfer-file-input"
                  onClick={(e) => {
                    e.target.value = null
                    if (disable) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const transferfilesss = e.target.files
                      const transferProcessFiles = Array.from(e.target.files)
                      if ((transferfilesss.length + files.length) > numberOfUpload) {     
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        transferProcessFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "UniversityTranscript";
                          element.typelabel = "University Transcript"

                         /* if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/
                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }         
                        })

                        if (count === 1) {
                          this.setState({ files: [...this.state.files,...this.state.transferFiles, ...Array.from(transferfilesss)], transferUploadFiles: [...transferUploadFiles, transferfilesss] })

                        } else if (count === 0) {
                           alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                  accept={acceptFiles} />


<input
                  type="file"
                  style={{ display: 'none' }}
                  multiple={true}
                  id="courseDescriptions-file-input"
                  onClick={(e) => {
                    e.target.value = null
                    if (disable) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const courseDescritionfilesss = e.target.files
                      const courseDescriptionProcessFiles = Array.from(e.target.files)
                      if ((courseDescritionfilesss.length + files.length) > numberOfUpload) {     
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        courseDescriptionProcessFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "CourseDescriptions";
                          element.typelabel = "Course Descriptions"

                         /* if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/
                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }         
                        })

                        if (count === 1) {
                          this.setState({ files: [...this.state.files,...this.state.courseDescriptionsFiles, ...Array.from(courseDescritionfilesss)], courseDescriptionsUploadFiles: [...courseDescriptionsUploadFiles, courseDescritionfilesss] })

                        } else if (count === 0) {
                           alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                  accept={acceptFiles} />


<input
                  type="file"
                  style={{ display: 'none' }}
                  multiple={true}
                  id="gradingScheme-file-input"
                  onClick={(e) => {
                    e.target.value = null
                    if (disable) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const gradingSchemefilesss = e.target.files
                      const gradingSchemeProcessFiles = Array.from(e.target.files)
                      if ((gradingSchemefilesss.length + files.length) > numberOfUpload) {     
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        gradingSchemeProcessFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "GradingScheme";
                          element.typelabel = "Grading Scheme"

                         /* if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/
                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }         
                        })

                        if (count === 1) {
                          this.setState({ files: [...this.state.files,...this.state.gradingSchemeFiles, ...Array.from(gradingSchemefilesss)], gradingSchemeUploadFiles: [...gradingSchemeUploadFiles, gradingSchemefilesss] })

                        } else if (count === 0) {
                           alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                  accept={acceptFiles} />

                  <input
                  type="file"
                  style={{ display: 'none' }}
                  multiple={true}
                  id="personalPic-file-input"
                  onClick={(e) => {
                    e.target.value = null
                    if (disable) {
                      e.preventDefault()
                    }
                  }}
                  onChange={(e) => {
                    if (!disable) {
                      const personalPicFilesss = e.target.files
                      const personalPicProcessFiles = Array.from(e.target.files)
                      if ((personalPicFilesss.length + files.length) > numberOfUpload) {     
                        alert(`You can add upto ${numberOfUpload} files only!`)
                      } else {
                        let count = 0
                        personalPicProcessFiles.forEach(element => {
                          const extension = '.' + element.name.split('.')[(element.name.split('.')).length - 1]
                          element.label = "PersonalPicture";
                          element.typelabel = "Passport Size Photo"

                         /* if (acceptArray.indexOf(extension) === -1) {
                            count = 1
                          }*/
                          for(var i = 0 ; i < acceptArray.length ; i++)
                          {
                            if(acceptArray[i].indexOf(extension.toLowerCase()) !==-1)
                            {
                              if(Math.round((element.size / 1000000) * 100) / 100 <= maxAttachmentSize)
                              {
                                count = 1
                                break;
                              }
                              else
                              {
                                alert('Upload Failed,maximum allowed upload size per Attachment was exceeded !')
                                count = -1
                                break;
                              }
                            }
                          }         
                        })

                        if (count === 1) {
                          this.setState({ files: [...this.state.files,...this.state.personalPicFiles, ...Array.from(personalPicFilesss)], personalPicUploadFiles: [...personalPicUploadFiles, personalPicFilesss] })

                        } else if (count === 0) {
                           alert('Please Upload Supported File Type only!') }
                      }
                    }
                  }}
                  accept={acceptFiles} />


                <table cellPadding="0" cellSpacing="0" className="file-table">
                  <tr>
                    <td style={{ paddingRight: "20px" }}><b>File:</b></td>
                    <td>
                      <label htmlFor="file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}High School Transcript or Report Cards </span>
                          <span style={{color:'red'}}>*</span>
                        </span>
                      </label>
                    </td>
                  </tr>
            
                  <br/>
                  <tr>
                    <td><b>File:</b></td>
                    <td>
                      <label htmlFor="nationalID-file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}National ID or Birth Certificate </span>
                        </span>
                      </label>
                      <label className='upload-warning' style={{color:'red',fontSize:'14px',fontStyle:'italic' }} >* : Required for Egyptian</label>
                     
                    </td>
                  </tr>
                  <br/>
                  <tr>
                    <td><b>File:</b></td>
                    <td>
                      <label   htmlFor="passport-file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}Passport</span>
                        </span>
              
                      </label>
                      <label className='upload-warning' style={{color:'red',fontSize:'14px',fontStyle:'italic' }} >* : Required for Non-Egyptian</label>
                      
                    </td>
                   
                  </tr>
                  <br/>
                  <tr>
                    <td><b>File:</b></td>
                    <td>
                      <label htmlFor="englishAssessment-file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}English Proficiency Assessment</span>
                        </span>
                      </label>
                      <label className='upload-warning' style={{color:'red',fontSize:'14px',fontStyle:'italic' }} >* : Required if you have taken a Test</label>
                    </td>
                  </tr>
                  <br/>
                  <tr>
                    <td><b>File:</b></td>
                    <td>
                      <label htmlFor="transfer-file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}Universtiy Transcript</span>
                        </span>
                      </label>
                      <label className='upload-warning' style={{color:'red',fontSize:'14px',fontStyle:'italic' }} >* : Required if you are a transfer student</label>
                    </td>
                  </tr>


                  <br/>
                  <tr>
                    <td><b>File:</b></td>
                    <td>
                      <label htmlFor="courseDescriptions-file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}Course Descriptions:A description of the modules taught during your years of study at university</span>
                        </span>
                      </label>
                      <label className='upload-warning' style={{color:'red',fontSize:'14px',fontStyle:'italic' }} >* : Required if you are a transfer student</label>
                    </td>
                  </tr>


                  <br/>
                  <tr>
                    <td><b>File:</b></td>
                    <td>
                      <label htmlFor="gradingScheme-file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}Grading Scheme:The grading system used to assess your grades</span>
                        </span>
                      </label>
                      <label className='upload-warning' style={{color:'red',fontSize:'14px',fontStyle:'italic' }} >* : Required if you are a transfer student</label>
                    </td>
                  </tr>



                  <br/>
                  <tr>
                    <td><b>File:</b></td>
                    <td>
                      <label htmlFor="personalPic-file-input" className={disable ? 'input-file disabled' : 'input-file'}>
                        <span>
                          <i className="fa fa-folder-open-o" aria-hidden="true"></i>
                          <span>{' '}Passport Size Photo</span>
                        </span>
                      </label>
                      <label className='upload-warning' style={{color:'red',fontSize:'14px',fontStyle:'italic' }} >* : Required. Kindly note that this photo will be used for your University ID.</label>
                    </td>
                  </tr>
          
                    </table>
              </div>
              <div onClick={() => this.setState({ showModal: true })} style={{ cursor: 'pointer' }} />

            </div>
            {error && <p style={{ color: color, fontSize: 12, }}>{error}</p>}
            {showFiles.length ? <div onClick={() => {
              if (disable) {
                return
              }
              console.log('')
            }}>
              <p className="table-heading">Your Attachments</p>
              <div className='document-table-wrapper'>
                <table cellPadding="0" cellSpacing="0" className="file-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Size (MB)</th>
                      <th>Type</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {showFiles}
                  </tbody>
                </table>
              </div>
              <p className="file-size">Total Size : {Math.round((total / 1000000) * 100) / 100}</p>
            </div> : <div className="file-size no-file"> You haven&apos;t uploaded any documents yet.</div>
            }
            <button
              className="upload-file-btn save"
              /* onClick={() => this.setState({ disable: true })} */
              onClick={this.handleSubmit}
              disabled={disable || submitLoading}
            >
              {submitLoading ? <img src={submit} alt="Loading..." style={{ width: 18, height: 18 }} /> : 'Submit'}
            </button>
            {showModal
              ? <div className="modal-bg">
                <div className="modal">
                  <div className="header" style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between', margin: 2 }}>
                    <p>Supported File Types</p>
                    <p onClick={() => this.setState({ showModal: false })} style={{ cursor: 'pointer' }}>x</p>
                  </div>
                  <div>
                    <ul>
                      {accepts.map(element => {
                        return <li key={element.name + ' ' + element.type} style={{ margin: 2 }}>{element.name}</li>
                      })}
                    </ul>
                  </div>
                </div>
              </div> : null}
          </div>
        </div>
      </div>
    )
  
  
  
  
  
  }
}
UploadDocuments.propTypes = {
  onClick: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number,
  token: PropTypes.string,
  history: PropTypes.object.isRequired
}

